import * as React from 'react';



export default class Collapse extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <circle id="Oval-5" cx="12" cy="12" r="12"></circle>
        <polyline id="Path-5" stroke="currentColor" strokeWidth="1.5" transform="translate(11.765625, 12.251224) scale(1, -1) translate(-11.765625, -12.251224) " points="7 10 11.5024486 14.5024486 16.53125 10"></polyline>
      </svg>
    )
  }
}
